import { Modelo } from '@ext/index';
import * as Types from './Publicacion.types';
import moment, { Moment } from 'moment';
import { Categoria } from '@/__env/lib/Web/Categorias/Categoria.nav';
import { isNumber, isObject, isString } from 'util';
import { Articulo } from '@/__env/lib/Articulos';


export class IPublicacion extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public Codigo: string = '';
    public Titulo: string = '';
    public Imagen: string = '';
    public Miniatura: string = '';
    public URL: string = '';
    public Precios = {
        Final: 0,
        Neto: 0,
    };

    //public Marca = new Marca();
    public Estado: Types.Estados = Types.Estados.NoEspecificado;
    public Articulo: Articulo = new Articulo();
    public Categoria: Categoria = new Categoria();


    public getJson(): any
    {
        let json: any = {};

        json.id = this.Id;


        return json;
    }


    public set(): boolean
    {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.Codigo = this.Json.articulo;
        this.Estado = Types.Estados.toTipo(this.Json.estado);
        this.Titulo = this.Json.titulo;
        if ( this.Titulo )
            this.Titulo = this.Titulo.toCapitalCase();

        this.Precios.Neto = this.Json.precio_neto;
        this.Precios.Final = this.Json.precio_final;

        if ( isString( this.Json.articulo ) )
            this.Categoria.Id = this.Json.categoria;
        if ( isObject( this.Json.articulo ) )
            this.Articulo = new Articulo( this.Json.articulo );

        //this.Marca.Id = this.Json.marca;
        if ( isNumber( this.Json.categoria ) )
            this.Categoria.Id = this.Json.categoria;
        if ( isObject( this.Json.categoria ) )
            this.Categoria = new Categoria( this.Json.categoria );


        this.Imagen = this.Json.imagen;
        this.Miniatura = this.Json.miniatura;
        this.URL = '/item/' + this.Id;

        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IPublicacion )
    {
        this.Model = Model;
    }

    public Model: IPublicacion;
}